// extracted by mini-css-extract-plugin
export default {"container":"Bw-z","ratingLayout":"Cw-z","ratingLabel":"Dw-z","nonInteractiveRatingLabel":"Ew-z"};